export type EmbedVideoProps = {
  src: string
  autoPlay?: boolean
}

export function EmbedVideo(props: EmbedVideoProps) {
  return <video {...props} controls width="100%" />
}
